import { createApp } from 'vue';
import App from './App.vue';
import './styles/style.scss';
// 导入主题管理器
import { loadTheme, getTheme, updateThemeColorMeta } from './styles/theme';
import router from '@/router';
import { bootstrap } from 'app';
// import 'amfe-flexible';

// 在应用启动前清理 Service Worker（不再默认注销，改为检查状态）
const cleanupServiceWorker = async () => {
    if ('serviceWorker' in navigator) {
        try {
            // 获取所有已注册的Service Worker
            // const registrations = await navigator.serviceWorker.getRegistrations();

            // // 注销所有非Firebase的Service Worker
            // for (const registration of registrations) {
            //     // 检查是否为Firebase Service Worker
            //     const scope = registration.scope;
            //     const isFirebaseServiceWorker = registration.active && (registration.active.scriptURL.includes('firebase-messaging-sw.js') || scope.includes('firebase-cloud-messaging'));

            //     if (!isFirebaseServiceWorker) {
            //         await registration.unregister();
            //         console.log('非Firebase Service Worker已注销:', registration.scope);
            //     } else {
            //         console.log('保留Firebase Service Worker:', registration.scope);
            //     }
            // }

            // 清除非Firebase相关的缓存
            // if ('caches' in window) {
            //     const cacheNames = await caches.keys();
            //     await Promise.all(
            //         cacheNames.map(cacheName => {
            //             // 跳过Firebase相关缓存
            //             if (!cacheName.includes('firebase') && !cacheName.includes('fcm')) {
            //                 return caches.delete(cacheName);
            //             }
            //             console.log('保留Firebase相关缓存:', cacheName);
            //             return Promise.resolve();
            //         })
            //     );
            //     console.log('非Firebase Service Worker缓存已清除');
            // }

            // 清除心跳记录
            localStorage.removeItem('sw_last_heartbeat');

            // 如果仍有活动的非Firebase Service Worker，发送SKIP_WAITING消息
            if (navigator.serviceWorker.controller) {
                const controllerUrl = navigator.serviceWorker.controller.scriptURL;
                if (!controllerUrl.includes('firebase-messaging-sw.js')) {
                    navigator.serviceWorker.controller.postMessage({ type: 'SKIP_WAITING' });
                }
            }

            // 如果页面是被非Firebase Service Worker控制的，刷新页面以完全移除Service Worker的控制
            if (navigator.serviceWorker.controller) {
                const controllerUrl = navigator.serviceWorker.controller.scriptURL;
                if (!controllerUrl.includes('firebase-messaging-sw.js')) {
                    // 设置标记，避免无限刷新
                    const hasRefreshed = sessionStorage.getItem('sw_cleaned');
                    if (!hasRefreshed) {
                        sessionStorage.setItem('sw_cleaned', 'true');
                        window.location.reload();
                    }
                }
            }
        } catch (error) {
            console.error('注销Service Worker失败:', error);
        }
    }
};

// 在应用启动前执行清理并设置监听 - 修改执行顺序
// 等待页面完全加载后再执行清理，确保不干扰Firebase初始化
// window.addEventListener('load', () => {
//     // 延迟执行清理操作，给Firebase Service Worker注册足够的时间
//     setTimeout(() => {
//         cleanupServiceWorker().then(() => {
//             console.log('Service Worker清理完成');
//         });
//     }, 3000); // 延迟3秒执行

//     setupServiceWorkerListeners();
// });

const app = createApp(App);

bootstrap(app)
    .then(() => {
        app.use(router).mount('#app');
    })
    .catch(err => {
        console.error('启动失败', err);
    });

// 监听页面可见性变化
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
        // 页面变为可见时检查
        setTimeout(() => {
            cleanupServiceWorker();
        }, 2000); // 延迟执行以确保不干扰Firebase
    }
});

import Vconsole from 'vconsole';

// 检查URL中是否包含vconsole=true参数
const shouldEnableVConsole = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('vconsole') === 'true';
};

if (shouldEnableVConsole()) {
    new Vconsole();
}

// 添加rem适配函数
function setRem() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
        // 移动端使用vw
        document.documentElement.style.fontSize = '10vw'; // 10vw = 37.5px (在375px宽度的设备上)
    } else {
        // PC端固定font-size为37.5px
        document.documentElement.style.fontSize = '75px';
    }
}

// 添加防抖函数
function debounce(fn: Function, delay: number) {
    let timer: NodeJS.Timeout | null = null;
    return function (this: any, ...args: any[]) {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
}

// 记录初始尺寸
let initialWidth = window.innerWidth;

// 处理窗口大小变化
const handleResize = debounce(() => {
    const currentWidth = window.innerWidth;

    // // 判断当前路由
    // const currentRoute = router.currentRoute.value;

    // // 如果当前是 liveMobile 页面，不刷新
    // if (currentRoute.name === 'liveMobile') {
    //     return; // 直接返回，不刷新
    // }

    // 否则宽度变化超过 50px 就刷新页面
    if (Math.abs(currentWidth - initialWidth) > 50) {
        window.location.reload();
    }
}, 300);

// 初始设置
setRem();

// 监听窗口变化
window.addEventListener('resize', () => {
    setRem();
    handleResize();
});
